import DOMPurify from 'dompurify';

const sanitizeEmbedlyHTML = (html) => DOMPurify.sanitize(html, {
    ADD_TAGS: ['iframe', 'div'],
    ADD_ATTR: ['frameborder', 'allowfullscreen', 'allow', 'scrolling'],
    FORBID_ATTR: ['onclick'],
});

const sanitizeHTML = (html) => DOMPurify.sanitize(html);

// Transforms "Apostro#039;phe" to "Apostro'phe"
const decodeHtmlEntities = (text) => {
    const parser = new DOMParser();
    return parser.parseFromString(text, 'text/html').body.textContent || '';
};

export {
    decodeHtmlEntities,
    sanitizeEmbedlyHTML,
    sanitizeHTML,
};
